module.exports = __webpack_public_path__ + "img/empty.7ce8bfd7.svg";